module.exports = __webpack_public_path__ + "static/media/icon-module-operational-panel-hover.f2dd9925.svg";